@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data title="Something went wrong" [showRetry]="true" (retry)="pageChange.emit(currentPage())" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="tableHeaderData()"
    [rows]="rows()"
    (toggleDropdown)="toggleDropdown($event)"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد ورديات تطابق الفلترة' : 'No route instances match your criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد ورديات' : 'No Route Instances Found'"
    [emptyContentDescription]="
      isArabic() ? 'لم يتم إنشاء أي ورديات بعد.' : 'No route instances have been created yet.'
    " />

  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPreviousPage()"
    (nextPage)="onNextPage()"
    (goToPage)="onGoToPage($event)"
    (changePageNumber)="onChangePageNumber($event)"
    (pageSizeChange)="onPageSizeChange()" />
  @if (showCancelDialog()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="isArabic() ? 'إلغاء وردية خط السير' : 'Cancel Route Instance'"
      [description]="
        isArabic()
          ? 'هل أنت متأكد أنك تريد إلغاء وردية خط السير؟'
          : 'Are you sure you want to cancel this route instance?'
      "
      [showComment]="true"
      [confirmContent]="isArabic() ? 'تأكيد' : 'Confirm'"
      [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
      (onCancel)="showCancelDialog.set(false)"
      (onSubmitWithComment)="onCancelSubmit($event)"
      [error]="cancelRouteError()" />
  }
  @if (showStartDialog()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="isArabic() ? 'بدء وردية خط السير' : 'Start Route Instance'"
      [description]="
        isArabic() ? 'هل أنت متأكد من بدء وردية خط السير هذه؟' : 'Are you sure you want to start this route Instance?'
      "
      [confirmContent]="isArabic() ? 'تأكيد' : 'Confirm'"
      [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
      (onCancel)="showStartDialog.set(false)"
      (onSubmit)="startRouteInstance.emit({ id: selectedInstanceId()!, comment: '' }); showStartDialog.set(false)" />
  }
  @if (showStartDialog()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="isArabic() ? 'بدء وردية خط السير' : 'Start Route Instance'"
      [description]="
        isArabic() ? 'هل أنت متأكد من بدء وردية خط السير هذه؟' : 'Are you sure you want to start this route Instance?'
      "
      [confirmContent]="isArabic() ? 'تأكيد' : 'Confirm'"
      [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
      (onCancel)="showStartDialog.set(false)"
      (onSubmitWithComment)="onStartSubmit($event)"
      [error]="startRouteInstanceError()"
      [showComment]="true" />
  }
}
